import { ErrorMessage, Field } from 'formik';
import React, { useEffect } from 'react';
import FormikInputField from '../../../common/components/FormikInputField/FormikInputField';
import { MessageBubble } from '../../../common/icons';
import './IMOInputField.scss';
import { recalculateEntriesForYard } from '../../config/mappers';
import { CapacityEntityEntry } from '../../types';
import IMODescriptionDrawer from './IMODescriptionDrawer';

const IMOInputField = ({
  isDrawerOpen,
  setFieldValue,
  entries,
  defaultEntries,
  defaultImoUnits,
}: {
  isDrawerOpen: boolean;
  entries?: CapacityEntityEntry[];
  defaultEntries?: CapacityEntityEntry[];
  defaultImoUnits?: number;
  setFieldValue?: (field: string, value: number) => void;
}) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  // close the IMO Drawer when the main drawer is being closed
  useEffect(() => {
    if (!isDrawerOpen) {
      setDrawerOpen(false);
    }
  }, [isDrawerOpen]);

  return (
    <>
      <div className="IMOInputField">
        <Field
          label="IMO"
          type="number"
          name="imoUnits"
          component={FormikInputField}
          {...(setFieldValue && entries && defaultEntries && defaultImoUnits !== undefined
            ? {
                input: (e) => {
                  setFieldValue('imoUnits', parseInt(e.target.value));
                  setFieldValue(
                    'entries',
                    // @ts-ignore
                    recalculateEntriesForYard(
                      entries,
                      defaultEntries,
                      'imoUnits',
                      defaultImoUnits,
                      parseInt(e.target.value),
                    ),
                  );
                },
              }
            : {})}
        />
        <ErrorMessage className="EventsDrawer__error" name="imoUnits" component="div" />
        <span className="IMOInputField__addon" onClick={() => setDrawerOpen(true)}>
          <MessageBubble className="IMOInputField__addon__icon" />
        </span>
      </div>
      <IMODescriptionDrawer open={drawerOpen} setOpen={setDrawerOpen} />
    </>
  );
};

export default IMOInputField;
